import React, { useState } from "react";
import emailjs from "@emailjs/browser";

const Contactform = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
    flexCheckDefault: false
  });

  const [status, setStatus] = useState(""); // Success or error message

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.message || !formData.phone || !formData.flexCheckDefault) {
      setStatus("Proszę uzupełnij wszystkie wymagane pola.");
      return;
    }

    const templateParams = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      company: formData.company,
      message: formData.message
    };

    try {
      await emailjs.send(
        "service_88jkx0e",      // replace
        "template_1j0x55c",     // replace
        templateParams,
        "JE6W99E5afI2EqFP5"       // replace
      );

      setStatus("Wiadomość wysłana poprawnie!");

      // Reset form
      setFormData({
        name: "",
        company: "",
        email: "",
        phone: "",
        message: "",
        flexCheckDefault: false
      });
    } catch (error) {
      console.error("EmailJS error:", error);
      setStatus("Coś poszło nie tak.");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-lg-6">
          <input
            type="text"
            name="name"
            placeholder="Imię i nazwisko"
            className="mb-3"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-lg-6">
          <input
            type="text"
            name="company"
            placeholder="Firma (opcjonalnie)"
            className="mb-3"
            value={formData.company}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="phone-no">
        <input
          type="tel"
          name="phone"
          placeholder="Numer telefonu"
          className="mb-3"
          value={formData.phone}
          onChange={handleChange}
          pattern="[0-9]{9,12}"
          title="Wprowadź prawidłowy numer (9–12 cyfr)"
          required
        />
      </div>
      <div className="email">
        <input
          type="email"
          name="email"
          placeholder="Adres e-mail"
          className="mb-3"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>
      <div className="message">
        <textarea
          name="message"
          placeholder="Wiadomość"
          rows="4"
          className="mb-3"
          value={formData.message}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-check d-flex mb-5">
        <input
          className="form-check-input me-2"
          type="checkbox"
          id="flexCheckDefault"
          name="flexCheckDefault"
          checked={formData.flexCheckDefault}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              flexCheckDefault: e.target.checked,
            }))
          }
        />
        <label className="form-check-label mb-0" htmlFor="flexCheckDefault">
          *Oświadczam, że zapoznałem/am się z treścią polityki prywatności i plików cookies oraz informacją o przetwarzaniu danych osobowych.
        </label>
      </div>
      <button type="submit" className="btn-contact ">
        Wyślij zapytanie
      </button>

      {status && (
        <div className="mt-3 alert alert-info" role="alert">
          {status}
        </div>
      )}
    </form>
  );
};

export default Contactform;
